import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function Impression() {

    return (


        <div>

            <div className='container-fluid impression'>
                <div>
                    <ol className="breadcrumb float-xl-right">
                        <li className="breadcrumb-item"><a href="/home">Home</a></li>
                        <li className="breadcrumb-item active">impression</li>
                    </ol>
                    <h1 className="page-header">Impression</h1>
                    <h5>Betreiber:</h5>
                </div>
                <div className='row mt-5'>
                    <div className='col-md-4 emailtext'>
                        <p>STT (Scan to Tell)</p>
                        <p>4MB Technical Service uG</p>
                        <p>Stenten Berg Str 31</p>
                        <p>51702 Bergneustadt </p>
                        <p>Telefone: 0049 15145251327</p>
                        <p>Fax:0049 2261 9929467</p>
                        <p>Email: info@qrcode-stt.com</p>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-md-12 emailtext'>
                        <b>Lorem Ipsum is simply dummy text</b>
                        <p>STT Verwaltung SARL,37,Rue d'Anvers</p>
                        <p>Geschaftsfuhrer : <b>Mubashar Ahmad Minhas</b></p>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-4 emailtext'>
                        <p>AG Wurzburg XXX XXXX</p>
                        <p>USt-ID-Nr. : XXXXXXX</p>
                        <p>IHK Wurzburg-Schweinfurt</p>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-md-12 emailtext'>
                        <p>Online-Streitbeilegung gema Art.14 Abs. 1 ODR-Verordnung : </p>
                        <p>Die Europaische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Diese finden Sie hier
                            Die is nicht bereit und verpflichtet ,an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle telizunehmen.
                        </p>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className='col-md-12 emailtext'>
                        <b>*regularer Festnetztarif Ihres Telefonanbieters,ggf. kostenfrei bei Flatrate; Mobilfunktarif ggf. abweichend</b>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Impression;